import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string;
  description?: string;
};

const SEO = ({ title, description }: Props) => {
  const { t } = useTranslation();

  return (
    <Helmet>
      <title>
        {title} – {t('app.title')}{' '}
      </title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default SEO;
